import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/logo-login.png'
import _imports_1 from '../../assets/background.png'


const _hoisted_1 = { class: "d-flex flex-column align-center pb-10" }
const _hoisted_2 = { class: "d-flex justify-center" }

import { inject } from 'vue'
import { ApiPluginInterface } from '@/plugins/api-plugin'
import { useForm } from 'vee-validate'
import SignInDto from '@/interfaces/common/SignIn.dto'
import { signInDtoSchema } from '@/schemas/common/signIn.dto.schema'
import { useAuthStore } from '@/stores/useAuthStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'SignInPage',
  setup(__props) {

const api = inject<ApiPluginInterface>('api')

const storeAuth = useAuthStore()

const { errors, handleSubmit, defineField, isSubmitting } = useForm<SignInDto>({
    validationSchema: signInDtoSchema,
})

const onSubmit = handleSubmit(async (values) => {
    await storeAuth.login(values.email, values.password, api)
})

const [email, emailAttrs] = defineField('email')
const [password, passwordAttrs] = defineField('password')

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "fill-height pa-0 pb-0",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "fill-height" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { class: "d-flex justify-center align-self-center flex-column" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "10",
                    class: "d-flex justify-center align-self-center flex-column ml-auto mr-auto"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _cache[3] || (_cache[3] = _createElementVNode("img", {
                          alt: "",
                          src: _imports_0,
                          class: "align-self-center",
                          height: "60px"
                        }, null, -1)),
                        _createVNode(_component_router_link, {
                          to: "/",
                          class: "text-decoration-none font-weight-bold"
                        }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode(" Channel Optimiser ", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-h3 pb-3 text-center" }, "Welcome Back", -1)),
                      _createVNode(_component_v_btn, {
                        disabled: "",
                        "prepend-icon": "mdi-google",
                        variant: "outlined",
                        rounded: "xl",
                        size: "x-large",
                        class: "text-none"
                      }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode(" Login with Google ", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "pa-5 text-center" }, "or login by email:", -1)),
                      _createVNode(_component_v_form, { onSubmit: _unref(onSubmit) }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_label, null, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createTextVNode("UserName", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_text_field, _mergeProps({
                            placeholder: "UserName",
                            modelValue: _unref(email),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : null))
                          }, _unref(emailAttrs), {
                            "error-messages": _unref(errors).email,
                            variant: "solo",
                            density: "compact",
                            autocomplete: "off"
                          }), null, 16, ["modelValue", "error-messages"]),
                          _createVNode(_component_v_label, null, {
                            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                              _createTextVNode("Password", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_text_field, _mergeProps({
                            placeholder: "Password",
                            type: "password",
                            modelValue: _unref(password),
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(password) ? (password).value = $event : null))
                          }, _unref(passwordAttrs), {
                            "error-messages": _unref(errors).password,
                            variant: "solo",
                            density: "compact",
                            autocomplete: "off"
                          }), null, 16, ["modelValue", "error-messages"]),
                          _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_v_btn, {
                              class: "mt-2 text-none",
                              type: "submit",
                              loading: _unref(isSubmitting),
                              rounded: "xl",
                              size: "x-large",
                              variant: "elevated",
                              "base-color": "primary",
                              disabled: Object.keys(_unref(errors)).length > 0
                            }, {
                              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                _createTextVNode(" Login ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["loading", "disabled"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["onSubmit"]),
                      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "pa-10 text-center" }, "Version 1.0", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { class: "bg-white" }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createElementVNode("div", { class: "text-h4 pa-10" }, " Helping the World's Leading Brands to Grow Profitably & Sustainably Online ", -1),
              _createElementVNode("img", {
                alt: "",
                src: _imports_1
              }, null, -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})